import { ApiRequest, RequestMethod } from "../../request";
import { XpHistory } from "../../../model/Dto/XpHistory";

export async function addFighterXp(fighterId: string, xpInfo: XpHistory): Promise<boolean> {
    const apiRequest = new ApiRequest();
    apiRequest.setMethod(RequestMethod.POST);
    apiRequest.setUrl(`/api/fighter/${fighterId}/xp`);
    apiRequest.setJsonBody({
        fighterId,
        xp: xpInfo.xp,
        description: xpInfo.description,
        date: xpInfo.date,
    });

    const response: any = await apiRequest.send();
    return response.status === 200;
}
